import { yupResolver } from '@hookform/resolvers/yup';
import { FieldValues, Resolver } from 'react-hook-form';

/** Centralizes the unavoidable RHF↔Yup resolver type-bridge cast so call sites stay cast-free. */
export const createYupResolver = <T extends FieldValues>(
  schema: Parameters<typeof yupResolver>[0],
  /** `raw` submits the values as typed, without Yup's cast and defaults. */
  resolverOptions?: { raw: true }
): Resolver<T> =>
  (resolverOptions
    ? yupResolver(schema, undefined, resolverOptions)
    : yupResolver(schema)) as unknown as Resolver<T>;
